"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PrepCombo = void 0;
exports.PrepCombo = {
    DAMAGE_PROTECTION: "DAMAGE_PROTECTION",
    BAGGING_PROTECTION: "BAGGING_PROTECTION",
    FBA_PARCEL_STANDARD: "FBA_PARCEL_STANDARD",
    FBA_FREIGHT_STANDARD: "FBA_FREIGHT_STANDARD",
};
//# sourceMappingURL=prep-combo.js.map